import { render, staticRenderFns } from "./IndexStatistics.vue?vue&type=template&id=282c2393&scoped=true"
import script from "./IndexStatistics.vue?vue&type=script&lang=js"
export * from "./IndexStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282c2393",
  null
  
)

export default component.exports